import React, { useEffect, useContext, useState, useMemo } from "react";
import "./dashboard-content.component.scoped.scss";
import DashboardFirstBlock from "../dashboard-first-block/dashboard-first-block.component";
import DashboardSecondBlock from "../dashboard-second-block/dashboard-second-block.component";
import DashboardThirdBlock from "../dashboard-third-block/dashboard-third-block.component";
import { GlobalContext } from "../../../../store";
import { Box } from "@material-ui/core";
import { DashboardService } from "../../../../services/dashboard/dashboard.service";
import { MapperService } from "../../../../services/mapper/mapper.service";
import moment from "moment";
import { DashboardCountCards } from "../../../../statics/countCards";
import DocumentsComponent from "../documents/documents.component";

export default function DashboardContent() {
  const dashboardService = useMemo(() => new DashboardService(), []);
  const mapperService = useMemo(() => new MapperService(), []);
  const { user } = useContext(GlobalContext);

  const [counts, setCounts] = useState<any>([]);
  const [publishedCases, setPublishedCases] = useState<any>({});
  const [usersRoles, setUsersRoles] = useState<any>({});
  const [statusChart, setStatusChart] = useState();

  // const [categoriesChart, setCategoriesChart] = useState();

  const fetchData = async () => {
    const dashboardData = await dashboardService.getDashboardData();
    const mappedCounts = mapperService.mapCounts(
      dashboardData.counts,
      DashboardCountCards,
    );
    // const mappedCases = mapperService.mapTableCards(
    //   dashboardData.cases,
    //   "PROJECTS",
    // );

    const mappedUsers = mapperService.mapTableCards(
      dashboardData.users,
      "TEAM",
    );

    const mappedPublishedCases = mapperService.mapTableCards(
      dashboardData.publishedCases,
      "PUBLISHED",
    );

    setPublishedCases(mappedPublishedCases);
    setUsersRoles(mappedUsers);
    setCounts(mappedCounts);
    // setCases(mappedCases);
  };

  const fetchCharts = async () => {
    const durationDate = {
      from: moment().subtract(12, "months").format("YYYY-MM-DD"),
      to: moment().add(1, "days").format("YYYY-MM-DD"),
    };

    const statusChartData = await dashboardService.getStagesChartData(
      durationDate,
    );
    setStatusChart(statusChartData);
  };

  useEffect(() => {
    fetchData();
    fetchCharts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="dashboard-content">
      <DashboardFirstBlock counts={counts} />
      <DocumentsComponent />
      <DashboardSecondBlock cases={publishedCases} user={user} />
      <DashboardThirdBlock statusChart={statusChart} usersRoles={usersRoles} />
    </Box>
  );
}
